videojs.addLanguage('en', {
	"Rate": "Rate",
	"Quality": "Quality"
});